export default __webpack_public_path__ + "static/media/AetherPhoto3.910b2f6e.jpg";